// Import all translation resources
import enCommon from "./locales/en/common.json";
import deCommon from "./locales/de/common.json";
import enDocuments from "./locales/en/documents.json";
import deDocuments from "./locales/de/documents.json";
import enAudits from "./locales/en/audits.json";
import deAudits from "./locales/de/audits.json";
import enAuth from "./locales/en/auth.json";
import deAuth from "./locales/de/auth.json";
import enSidebar from "./locales/en/sidebar.json";
import deSidebar from "./locales/de/sidebar.json";
import enSettings from "./locales/en/settings.json";
import deSettings from "./locales/de/settings.json";
import enDashboard from "./locales/en/dashboard.json";
import deDashboard from "./locales/de/dashboard.json";
import enChat from "./locales/en/chat.json";
import deChat from "./locales/de/chat.json";
import enReports from "./locales/en/reports.json";
import deReports from "./locales/de/reports.json";

// Combine all resources following legacy structure
export const resources = {
  en: {
    common: enCommon,
    documents: enDocuments,
    audits: enAudits,
    auth: enAuth,
    sidebar: enSidebar,
    settings: enSettings,
    dashboard: enDashboard,
    chat: enChat,
    reports: enReports,
  },
  de: {
    common: deCommon,
    documents: deDocuments,
    audits: deAudits,
    auth: deAuth,
    sidebar: deSidebar,
    settings: deSettings,
    dashboard: deDashboard,
    chat: deChat,
    reports: deReports,
  },
} as const;
